import {
    ChangeDetectionStrategy,
    Component,
    effect,
    ElementRef,
    inject,
    OnDestroy,
    Signal,
    viewChild
} from "@angular/core";
import {navParam} from "../../navigation/navigation-params";
import {Page} from "../../navigation/page";
import {PaymentModel} from "../payment.model";
import {ThreeDSResult} from '../payment';
import {ModalPageLayoutComponent} from '../../page-layout/modal-page-layout/modal-page-layout.component';

@Component({
    selector: "woa-adyen-3ds-page",
    templateUrl: "./adyen-3ds-page.component.html",
    styleUrl: "./adyen-3ds-page.component.scss",
    providers: [{provide: Page, useExisting: Adyen3dsPageComponent}],
    imports: [
        ModalPageLayoutComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Adyen3dsPageComponent extends Page implements OnDestroy {
    public paymentModel: PaymentModel = inject(PaymentModel);

    private readonly threeDsHolder: Signal<ElementRef> = viewChild.required("threeDsHolder");

    private readonly action: Signal<any> = navParam.required<any>("action");

    private adyenCheckout: any;
    private adyen3ds: any;
    private destroyed: boolean = false;

    constructor() {
        super();
        effect(() => this.setup());
    }

    ngOnDestroy(): void {
        this.destroyed = true;
    }

    override onDidDismissPage(): void {
        this.adyen3ds?.unmount();
    }

    private async setup(): Promise<void> {
        if (this.destroyed || !this.paymentModel.paymentPlatformPublicKey() || !this.threeDsHolder()) {
            return;
        }

        // noinspection JSUnusedGlobalSymbols
        this.adyenCheckout = await (<any>window).AdyenWeb.AdyenCheckout({
            clientKey: this.paymentModel.paymentPlatformPublicKey(),
            environment: this.paymentModel.paymentPlatformLiveMode() ? "live-au" : "test",
            locale: "en_US",
            countryCode: "AU",
            onAdditionalDetails: (state: any) => this.dismiss(new ThreeDSResult(true, btoa(JSON.stringify(state.data))))
        });
        // noinspection JSUnusedGlobalSymbols
        this.adyen3ds = this.adyenCheckout.createFromAction(this.action(), {
            challengeWindowSize: "05"
        }).mount(this.threeDsHolder().nativeElement);
    }
}
